export default {"src":"/_next/static/media/icon-eye-closed.46b3d56d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};